module.exports = __webpack_public_path__ + "static/media/1-roup-2-3-x@2x.95623f63.png";